import React from 'react';
import { WhatsappMessage } from '../../../types/whatsapp';

export const MessageReplyPreview = ({ message }: { message: WhatsappMessage }) => {
    const content = message.content as any;
    
    switch (message.type) {
        case 'image':
            return <div className="d-flex align-items-center gap-1 text-truncate"><i className="ri-image-line"></i> <span>Foto</span></div>;
        case 'video':
            return <div className="d-flex align-items-center gap-1 text-truncate"><i className="ri-video-line"></i> <span>Video</span></div>;
        case 'audio':
            return <div className="d-flex align-items-center gap-1 text-truncate"><i className="ri-mic-fill"></i> <span>Audio</span></div>;
        case 'document':
            return <div className="d-flex align-items-center gap-1 text-truncate"><i className="ri-file-text-line"></i> <span>{content?.filename || 'Documento'}</span></div>;
        case 'sticker':
            return <div className="d-flex align-items-center gap-1 text-truncate"><i className="ri-emotion-happy-line"></i> <span>Sticker</span></div>;
        case 'location':
            return <div className="d-flex align-items-center gap-1 text-truncate"><i className="ri-map-pin-2-line"></i> <span>Ubicación</span></div>;
        case 'text':
            return <div className="text-truncate">{typeof content === 'string' ? content : content?.text || 'Texto'}</div>;
        default:
            return <div className="text-truncate">Mensaje</div>;
    }
};
